<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <!-- <search-payment :show.sync="showFilterPop" @handlequery="handleFqueryFilter" /> -->
    <!-- <add-btn v-hasPermi="['cont:payment:add']" @add="handleAddContract" /> -->
    <van-tabs v-model="active" @change="handleClick" :ellipsis="false">
      <van-tab title="部门审核" name="0"></van-tab>
      <van-tab title="人力资源审核" name="3"></van-tab>
      <van-tab title="人力资源通过" name="6"></van-tab>
      <van-tab title="人力资源不通过" name="7"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item, index) in list" :key="index" @click="toDetails(item)" >
        <div style="display: flex; align-items: center; height:100%; width:100%">
          <div style="flex: 1;">
            <div class="custName-wrap" style="padding: 0;">
              <div class="custName">
                {{item.deptName}}
              </div>
            </div>
            <div style="color: #333; font-size: 12px">餐补人数：{{item.userCount}}人<span style="margin-left: 14px;">餐补次数：{{item.mealCount}}次</span></div>
            <div style="color: #333; font-size: 12px">餐补总费用(元)： {{item.mealMoney}}元</div>
            <div style="color: #333; font-size: 12px">{{item.checkUserName}}
              <span v-if="item.checkStatus == 0" style="color: #ff976a;">待审核</span>
              <span v-if="item.checkStatus == 4 || item.checkStatus == 6 || item.checkStatus == 7" style="color: #67C23A">审核通过</span>
              <span v-if="item.checkStatus == 5" style="color: #F56C6C">审核不通过</span>
            </div>
          </div>
          <!-- <van-button size="mini" type="info" v-hasPermi="['admi:overTimeStatistics:edit']" v-if="item.checkStatus=='0'" @click.stop="handleReviewer(item)">事业部审核</van-button> -->
          <van-button size="mini" type="info" v-hasPermi="['admi:overTimeStatistics:hrCheck']" v-if="item.checkStatus=='4'" @click.stop="handleHrReviewer(item)">人力资源审核</van-button>
          <van-icon v-if="item.checkStatus!='4'" style="flex:0.1;" color="#c1c1c1" name="arrow" size="16" class="arrow-color" />
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <!-- <dialog-payment :show='paymentFormShow' :isAdd="true" @handleAddContractCancel='handleAddContractCancel' @beforeClose='addContractBeforeClose'></dialog-payment> -->
    <van-dialog v-model="verifyFormShow" title="审核" width="95%" style="height:45%" class="verifyClue" :beforeClose="verifyBeforeClose" show-cancel-button>
      <van-form ref="verifyForm" validate-trigger="onSubmit">
        <van-cell title="确认状态：" required v-if="verify == '45'">
          <template>
            <van-radio-group v-model="verifyForm.checkStatus" direction="horizontal">
              <van-radio name="4" clickable @click="verifyForm.checkStatus = '4'">通过</van-radio>
              <van-radio name="5" clickable @click="verifyForm.checkStatus = '5'">不通过</van-radio>
            </van-radio-group>
          </template>
        </van-cell>
        <van-cell title="确认状态：" required v-if="verify == '67'">
          <template>
            <van-radio-group v-model="verifyForm.checkStatus" direction="horizontal">
              <van-radio name="6" clickable @click="verifyForm.checkStatus = '6'">通过</van-radio>
              <van-radio name="7" clickable @click="verifyForm.checkStatus = '7'">不通过</van-radio>
            </van-radio-group>
          </template>
        </van-cell>
        <van-field
          v-if="verify == '45'"
          v-model="verifyForm.checkReason"
          rows="2"
          autosize
          label="审核意见"
          placeholder="请输入审核意见"
          type="textarea"
          show-word-limit
          :rules="verifyForm.checkStatus == '5'?[{ required: true }]:[]" :required="verifyForm.checkStatus == '5'?true:false"
        />
        <van-field
          v-if="verify == '67'"
          v-model="verifyForm.checkHrReason"
          rows="2"
          autosize
          label="审核意见"
          placeholder="请输入审核意见"
          type="textarea"
          show-word-limit
          :rules="verifyForm.checkStatus == '7'?[{ required: true }]:[]" :required="verifyForm.checkStatus == '7'?true:false"
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import mealTonic from '@/api/admi/mealTonic'
// import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
// import SearchPayment from '../components/contract/SearchPayment.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import { Toast } from 'vant'
// import AddBtn from '@/components/common/AddBtn'
// import DialogPayment from '../components/DialogPayment.vue'

export default {
  name: 'approve',
  components: {
    // AddBtn,
    SearchComponent,
    // SearchPayment,
    EmptyComponent,
    TotalComponent
    // DialogPayment,
    // [Tab.name]: Tab,
    // [Tabs.name]: Tabs
  },
  data() {
    return {
      add_show: false,
      isEmpty: false,
      active: '0',
      loading: false,
      finished: false,
      list: [],
      total: 0,
      showFilterPop: false,
      custList: [],
      // paymentFormShow: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        deptId: null,
        deptName: null,
        userName: null,
        monthStr: null,
        checkStatus: '0',
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      verify: '45',
      verifyFormShow: false,
      verifyForm: {}
    }
  },
  created() {
    this.queryParams.monthStr = this.getPreMonth()
    // this.queryParams.monthStr = '2022年10月'
    this.handleList()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '事业部餐补审批'
    },
    getNowMonth() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      month = month > 9 ? month : '0' + month
      var nowMonth = year + '-' + month
      return nowMonth
    },
    /** 获取上一个月 */
    getPreMonth() {
      var arr = this.getNowMonth().split('-')
      var year = arr[0] // 获取当前日期的年份
      var month = arr[1] // 获取当前日期的月份

      var year2 = year
      var month2 = parseInt(month) - 1
      if (month2 == 0) {
        // 1月的上一月是前一年的12月
        year2 = parseInt(year2) - 1
        month2 = 12
      }

      if (month2 < 10) {
        // 10月之前都需要补0
        month2 = '0' + month2
      }
      var preMonth = year2 + '年' + month2 + '月'
      return preMonth
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.queryParams.deptName = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      this.$router.push({
        path: '/admi/mealTonic/mealReview',
        query: { id: item.overtimeStatisticsId, deptId: item.deptId }
      })
    },
    handleClick(tab) {
      this.list = []
      this.queryParams.checkStatus = tab
      this.handleList()
    },
    async handleList() {
      this.loading = true
      const res = await mealTonic.listMealTonicMain(this.queryParams)
      if (res.code === 200) {
        console.log(res)
        if (res.data.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.data.rows)
        this.queryParams.pageNum += 1
        this.total = res.data.total
        this.finished = this.list.length >= res.data.total
        this.loading = false
      }
    },
    onLoad() {
      this.handleList()
    },
    handleReviewer(row) {
      this.verifyForm = { ...row, checkStatus: '4' }
      // this.verifyForm.checkStatus = '4'
      this.verify = '45'
      this.verifyForm.isCause = '1'
      this.verifyFormShow = true
    },
    handleHrReviewer(row) {
      this.verifyForm = { ...row, checkStatus: '6' }
      // this.verifyForm.checkStatus = '6'
      this.verify = '67'
      this.verifyForm.isCause = '2'
      this.verifyFormShow = true
    },
    // 审核
    async verifyBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.verifyForm.validate()
          mealTonic.auditMealTonicMain(this.verifyForm).then(response => {
            if (response.code == 200) {
              Toast.success('审核成功!')
              this.verifyFormShow = false
              setTimeout(() => {
                this.queryCustList()
              }, 500)
            }
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
.verifyClue /deep/.van-dialog__content {
  height: 64%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
</style>
